// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-contact-display {
  width: 100%;
  margin-bottom: 12px;
  font-size: 14px;
  color: var(--mc-select-text);
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/select-contact/select-contact.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,mBAAA;EAEA,eAAA;EACA,4BAAA;AAAD","sourcesContent":[".select-contact-display {\r\n\twidth: 100%;\r\n\tmargin-bottom: 12px;\r\n\t// margin-top: 12px;\r\n\tfont-size: 14px;\r\n\tcolor: var(--mc-select-text);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
